import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CourierService } from '../../../shared/services/courier.service';
import { GetActiveVoucherDto, GetStopsRequest, GetStopsResponse, PostStopsRequest, GetActiveVoucherRequest, GetActiveVoucherResponse } from '../../../shared/models/courier.models';
import { ActiveUserLocalDataService } from '../../../shared/services/active-user-local-data.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  templateUrl: 'stops.component.html',
  styleUrls: ['./stops.component.scss']
})
export class StopsComponent implements OnInit {

  getStopsResponse: GetStopsResponse | null = null;
  loading: boolean = true;
  voucher: GetActiveVoucherDto | null = null;

  deliveredAddresses: number = 0;
  pickedUpAddresses: number = 0;
  stackingByTwoMen: number = 0;
  kilometers: number = 0;
  airport: number = 0;
  undeliveredAddresses: number = 0;
  cashOnDeliveryAddresses: number = 0;
  documentReturnAddresses: number = 0;
  express830: number = 0;
  express1000: number = 0;
  express1200: number = 0;
  b2cAddresses: number = 0;
  saturdayAddresses: number = 0;
  stackingAddresses: number = 0;
  eveningHours: number = 0;
  samedayAddresses: number = 0;
  sounds: number = 0;

  constructor(
    private courierService: CourierService,
    private activeUserLocalDataService: ActiveUserLocalDataService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.voucher = this.activeUserLocalDataService.getActiveCourierVoucher();
    this.loadStopList();
    this.retrieveActiveVoucher();
  }

  loadStopList() {
    this.loading = true;
    let activeVoucher = this.voucher;
  
    if (!activeVoucher) {
      activeVoucher = this.activeUserLocalDataService.activeServiceVoucher || this.activeUserLocalDataService.getActiveCourierVoucher();
    }
  
    if (activeVoucher) {
      const request: GetStopsRequest = { clientId: activeVoucher.clientsId };
      this.courierService.getStops(request).subscribe((response: GetStopsResponse) => {
        this.getStopsResponse = response;
        this.loading = false;
      }, error => {
        console.error('Error fetching stop list:', error);
        this.loading = false;
      });
    } else {
      console.error('Active voucher is null');
      this.router.navigate(['/voucher']);
      this.loading = false;
    }
  }

  retrieveActiveVoucher() {
    const request: GetActiveVoucherRequest = {};
    this.courierService.getActiveVouchers(request).subscribe((response: GetActiveVoucherResponse) => {
      this.voucher = response.voucher;
      this.setVoucherValues(response.voucher);
    }, error => {
      console.error('Error fetching active voucher:', error);
    });
  }

  setVoucherValues(voucher: GetActiveVoucherDto) {
    if (this.getStopsResponse?.stops?.useDeliveredAddresses) {
      this.deliveredAddresses = voucher.deliveredAddresses || 0;
    }
    if (this.getStopsResponse?.stops?.usePickedUpAddresses) {
      this.pickedUpAddresses = voucher.pickedUpAddresses || 0;
    }
    if (this.getStopsResponse?.stops?.useStackingByTwoMen) {
      this.stackingByTwoMen = voucher.stackingByTwoMen || 0;
    }
    if (this.getStopsResponse?.stops?.useKilometers) {
      this.kilometers = voucher.kilometers || 0;
    }
    if (this.getStopsResponse?.stops?.useAirport) {
      this.airport = voucher.airport || 0;
    }
    if (this.getStopsResponse?.stops?.useUndeliveredAddresses) {
      this.undeliveredAddresses = voucher.undeliveredAddresses || 0;
    }
    if (this.getStopsResponse?.stops?.useCashOnDeliveryAddresses) {
      this.cashOnDeliveryAddresses = voucher.cashOnDeliveryAddresses || 0;
    }
    if (this.getStopsResponse?.stops?.useDocumentReturnAddresses) {
      this.documentReturnAddresses = voucher.documentReturnAddresses || 0;
    }
    if (this.getStopsResponse?.stops?.useExpress_8_30) {
      this.express830 = voucher.express830 || 0;
    }
    if (this.getStopsResponse?.stops?.useExpress_10_00) {
      this.express1000 = voucher.express1000 || 0;
    }
    if (this.getStopsResponse?.stops?.useExpress_12_00) {
      this.express1200 = voucher.express1200 || 0;
    }
    if (this.getStopsResponse?.stops?.useB2cAddresses) {
      this.b2cAddresses = voucher.b2cAddresses || 0;
    }
    if (this.getStopsResponse?.stops?.useSaturdayAddresses) {
      this.saturdayAddresses = voucher.saturdayAddresses || 0;
    }
    if (this.getStopsResponse?.stops?.useStackingAddresses) {
      this.stackingAddresses = voucher.stackingAddresses || 0;
    }
    if (this.getStopsResponse?.stops?.useEveningHours) {
      this.eveningHours = voucher.eveningHours || 0;
    }
    if (this.getStopsResponse?.stops?.useSamedayAddresses) {
      this.samedayAddresses = voucher.samedayAddresses || 0;
    }
    if (this.getStopsResponse?.stops?.useSounds) {
      this.sounds = voucher.sounds || 0;
    }
  }

  saveClick() {
    const request: PostStopsRequest = {
      voucherId: this.voucher?.id,
      deliveredAddresses: this.deliveredAddresses,
      pickedUpAddresses: this.pickedUpAddresses,
      stackingByTwoMen: this.stackingByTwoMen,
      kilometers: this.kilometers,
      airport: this.airport,
      undeliveredAddresses: this.undeliveredAddresses,
      cashOnDeliveryAddresses: this.cashOnDeliveryAddresses,
      documentReturnAddresses: this.documentReturnAddresses,
      express_8_30: this.express830,
      express_10_00: this.express1000,
      express_12_00: this.express1200,
      b2cAddresses: this.b2cAddresses,
      saturdayAddresses: this.saturdayAddresses,
      stackingAddresses: this.stackingAddresses,
      eveningHours: this.eveningHours,
      samedayAddresses: this.samedayAddresses,
      sounds: this.sounds
    };
  
    this.courierService.postStops(request).subscribe(() => {
      this.navigateToVoucher();
    }, error => {
      console.error('Error posting stops:', error);
    });
  }

  navigateToVoucher() {
    this.router.navigate(['/voucher']);
  }
}